import InlineBtn from "components/shared/inlineBtn";
import Loader from "components/shared/loader";
import { scenarioQuestionTypesEnum } from "helpers/enums";
import { scenarioQuestion } from "helpers/models";
import React from "react";
import Buttons from "../buttons";
import Form from "./form";
import Show from "./show";

const ScenarioQuestions = (props) => {
    const onChange = ({ name, value }, i) => {
        const questions = props.questions.map((item, index) => {
            if (index === i) {
                const newValue = { ...item, [name]: value };
                if (
                    name === "questionType" &&
                    ![scenarioQuestionTypesEnum.SelectOne, scenarioQuestionTypesEnum.SelectMultiple].includes(value)
                ) {
                    newValue.answerOptions = [];
                }
                return newValue;
            } else {
                return item;
            }
        });
        props.onChange({ name: "questions", value: questions });
    };

    const addScenarioQuestion = () => {
        const { questions, scenario } = props;
        questions.push({ ...scenarioQuestion, editMode: true, scenarioId: scenario.id });
        props.onChange({ name: "questions", value: questions });
    };

    const toggleEditMode = (i) => {
        const question = props.questions[i];
        if (question.editMode) {
            props.resetQuestion(i);
        } else {
            onChange({ name: "editMode", value: !question.editMode }, i);
        }
    };

    return (
        <>
            <h5 className="text-muted">Список вопросов сценария</h5>
            {props.questions.map((item, i) => (
                <div className="card card-body mb-2" key={i}>
                    {item.isLoading && (
                        <div className="loader-snippet--disable-loader">
                            <Loader />
                        </div>
                    )}
                    {item.editMode ? (
                        <Form
                            questionOptions={props.questionOptions}
                            scenarioQuestion={item}
                            scenario={props.scenario}
                            onChange={(data) => onChange(data, i)}
                            removeAnswerOption={props.removeAnswerOption.bind(this, i)}
                        />
                    ) : (
                        <Show {...item} questionOptions={props.questionOptions} />
                    )}
                    <div className="pt-2">
                        <Buttons
                            editMode={item.editMode}
                            toggleEditMode={toggleEditMode.bind(this, i)}
                            saveItem={props.saveQuestion.bind(this, i)}
                            removeItem={item.id && props.removeQuestion.bind(this, i)}
                            hasDriverAnswers={props.hasDriverAnswers}
                        />
                    </div>
                </div>
            ))}
            {!props.hasDriverAnswers && <InlineBtn value="Добавить вопрос" action={addScenarioQuestion} cname="plus" />}
        </>
    );
};

export default ScenarioQuestions;
